import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

function Pagenotfound() {

    const [Orggenie_Error_PageNotFound, setOrggenie_Error_PageNotFound] = useState('');
    let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

    useEffect(() => { GetMasterSystemAlertList('Orggenie_Error_PageNotFound', 1) }, []);
    async function GetMasterSystemAlertList(message, type) {
        SystemAlerts?.filter((msg) => {
            if (msg?.Name == message && type == 1) {
                setOrggenie_Error_PageNotFound(msg?.Desc);
            }
        });
    }
    return (
        <div>
            <div className="container-fluid">
                <div className="row g-3">
                    <div className="error-container">
                        <div className="error-wrapper">
                            <div className="error-inner text-center">
                                <img className="light-image" src="images/404.png" alt="" />
                                <h3 className="dark-inverted">Lost, are we?</h3>
                                <p>
                                    {Orggenie_Error_PageNotFound}
                                </p>
                                <div className="button-wrap">
                                    <Link to='/' className="button h-button is-primary is-elevated">Return to Login</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Pagenotfound